// Immediate debug function
window.debugMediaGallery = function() {
  console.log('=== IMMEDIATE MEDIA GALLERY DEBUG ===');
  console.log('Page loaded at:', new Date().toISOString());

  const gallery = document.querySelector('media-gallery');
  console.log('Media gallery element found:', !!gallery);
  if (gallery) {
    console.log('Gallery element:', gallery);
    console.log('Gallery has thumbnails:', !!gallery.thumbnails);
    console.log('Gallery has viewer:', !!gallery.viewer);
    console.log('Gallery attributes:', gallery.attributes);

    // Check if thumbnails exist
    if (gallery.thumbnails) {
      const thumbs = gallery.thumbnails.querySelectorAll('[data-target]');
      console.log('Thumbnails found:', thumbs.length);
      thumbs.forEach((thumb, i) => {
        console.log(`Thumb ${i}:`, thumb, 'data-target:', thumb.getAttribute('data-target'));
      });
    } else {
      console.error('❌ No thumbnails container found!');
    }
  } else {
    console.error('❌ No media-gallery element found on page!');
  }
};

// Debug function to test thumbnail functionality
window.testThumbnails = function() {
  console.log('=== THUMBNAIL DEBUG TEST ===');
  const gallery = document.querySelector('media-gallery');
  if (!gallery) {
    console.error('No media-gallery element found');
    return;
  }

  console.log('Gallery element:', gallery);
  console.log('Thumbnails container:', gallery.thumbnails);
  console.log('Has hide-variants:', gallery.hasAttribute("data-hide-variants"));

  if (gallery.thumbnails) {
    const thumbnails = gallery.thumbnails.querySelectorAll('[data-target]');
    console.log('Found thumbnails:', thumbnails.length);

    thumbnails.forEach((thumb, index) => {
      const hasVariantClass = thumb.classList.contains('thumbnail-list-item--variant');
      const hasCurrentClass = thumb.classList.contains('is-current-variant-thumbnail');
      const isVisible = window.getComputedStyle(thumb).display !== 'none';

      console.log(`Thumbnail ${index}:`, {
        element: thumb,
        dataTarget: thumb.getAttribute('data-target'),
        hasButton: !!thumb.querySelector('button'),
        classes: thumb.className,
        hasVariantClass,
        hasCurrentClass,
        isVisible,
        shouldBeVisible: !hasVariantClass || hasCurrentClass
      });
    });
  }

  // Test clicking functionality
  console.log('🧪 Testing thumbnail click functionality...');
  if (gallery.testThumbnailClicks) {
    gallery.testThumbnailClicks();
  } else {
    // Fallback: Test clicking first thumbnail manually
    const firstThumb = gallery.thumbnails?.querySelector('[data-target]');
    if (firstThumb) {
      console.log('Testing click on first thumbnail...');
      firstThumb.click();
    }
  }
};

// Debug function to check variant hiding specifically
// Debug function to test click detection
window.testClickDetection = function() {
  console.log('=== CLICK DETECTION TEST ===');

  // Add global click listener to document
  document.addEventListener('click', function(event) {
    console.log('📍 GLOBAL CLICK DETECTED:', event.target, event.currentTarget);
    if (event.target.closest('[data-target]')) {
      console.log('🎯 CLICK ON THUMBNAIL ELEMENT:', event.target.closest('[data-target]'));
    }
  }, true); // Use capture phase

  console.log('✅ Global click listener added');
};

// Debug function to check if MediaGallery is initialized
window.checkMediaGalleryInit = function() {
  console.log('=== MEDIA GALLERY INITIALIZATION CHECK ===');

  const gallery = document.querySelector('media-gallery');
  if (!gallery) {
    console.error('❌ No media-gallery element found');
    return false;
  }

  console.log('✅ Media-gallery element found:', gallery);
  console.log('Gallery attributes:', Array.from(gallery.attributes).map(attr => `${attr.name}="${attr.value}"`));

  // Check if thumbnails exist
  if (!gallery.thumbnails) {
    console.error('❌ No thumbnails container found');
    return false;
  }

  console.log('✅ Thumbnails container found:', gallery.thumbnails);
  console.log('Thumbnails container ID:', gallery.thumbnails.id);

  // Check if constructor ran (by checking if our methods exist)
  if (typeof gallery.onThumbnailClick !== 'function') {
    console.error('❌ MediaGallery methods not found - constructor may not have run');
    return false;
  }

  console.log('✅ MediaGallery methods exist');

  const thumbs = gallery.thumbnails.querySelectorAll('[data-target]');
  console.log(`Found ${thumbs.length} thumbnails`);

  let listenersAttached = 0;
  thumbs.forEach((thumb, index) => {
    const hasListeners = thumb.getAttribute('data-listeners-attached') === 'true';
    const hasClickHandler = !!thumb._mediaGalleryClickHandler;
    const button = thumb.querySelector('button');
    const hasButtonHandler = button && !!thumb._mediaGalleryButtonHandler;

    console.log(`Thumbnail ${index}:`, {
      element: thumb,
      dataTarget: thumb.getAttribute('data-target'),
      hasListeners: hasListeners,
      hasClickHandler: hasClickHandler,
      hasButton: !!button,
      hasButtonHandler: hasButtonHandler,
      classes: thumb.className
    });

    if (hasListeners) listenersAttached++;
  });

  console.log(`${listenersAttached}/${thumbs.length} thumbnails have listeners attached`);

  return listenersAttached > 0;
};

// Test function to manually trigger MediaGallery click handler
window.testMediaGalleryClick = function() {
  console.log('=== MANUAL MEDIA GALLERY CLICK TEST ===');

  const gallery = document.querySelector('media-gallery');
  if (!gallery) {
    console.error('❌ No media-gallery element found');
    return;
  }

  if (!gallery.thumbnails) {
    console.error('❌ No thumbnails container found');
    return;
  }

  const thumbs = gallery.thumbnails.querySelectorAll('[data-target]');
  if (thumbs.length === 0) {
    console.error('❌ No thumbnails found');
    return;
  }

  console.log(`Found ${thumbs.length} thumbnails`);

  // Test the first thumbnail
  const firstThumb = thumbs[0];
  console.log('Testing first thumbnail:', firstThumb, 'data-target:', firstThumb.getAttribute('data-target'));

  if (typeof gallery.onThumbnailClick === 'function') {
    console.log('✅ MediaGallery.onThumbnailClick method exists');

    // Create a mock event object
    const mockEvent = {
      currentTarget: firstThumb,
      target: firstThumb,
      preventDefault: () => console.log('preventDefault called'),
      stopPropagation: () => console.log('stopPropagation called')
    };

    console.log('🧪 Calling MediaGallery.onThumbnailClick with mock event...');
    try {
      gallery.onThumbnailClick(mockEvent);
      console.log('✅ onThumbnailClick method called successfully');
    } catch (error) {
      console.error('❌ Error calling onThumbnailClick:', error);
    }
  } else {
    console.error('❌ MediaGallery.onThumbnailClick method not found');
  }
};

// Debug function to check if event listeners are attached
window.checkEventListeners = function() {
  console.log('=== EVENT LISTENER CHECK ===');
  const gallery = document.querySelector('media-gallery');

  if (!gallery) {
    console.error('❌ No media-gallery element found');
    return;
  }

  if (!gallery.thumbnails) {
    console.error('❌ No thumbnails container found');
    return;
  }

  const thumbs = gallery.thumbnails.querySelectorAll('[data-target]');
  console.log(`Found ${thumbs.length} thumbnails`);

  thumbs.forEach((thumb, index) => {
    console.log(`Thumbnail ${index}:`, {
      element: thumb,
      dataTarget: thumb.getAttribute('data-target'),
      hasClickListener: !!thumb.onclick || !!thumb._boundClickHandler,
      button: thumb.querySelector('button'),
      classes: thumb.className
    });

    // Test if we can manually trigger click
    const testClick = () => {
      console.log(`🧪 Manually triggering click on thumbnail ${index}`);
      thumb.click();
    };

    // Make test function available
    window[`testThumb${index}`] = testClick;
    console.log(`Run window.testThumb${index}() to test this thumbnail`);
  });
};

window.debugVariantHiding = function() {
  console.log('=== VARIANT HIDING DEBUG ===');
  const gallery = document.querySelector('media-gallery');
  if (!gallery) {
    console.error('No media-gallery element found');
    return;
  }

  console.log('Has hide-variants attribute:', gallery.hasAttribute("data-hide-variants"));
  console.log('Gallery viewer:', gallery.viewer);
  console.log('Gallery thumbnails:', gallery.thumbnails);

  if (gallery.thumbnails) {
    const thumbnails = gallery.thumbnails.querySelectorAll('[data-target]');
    console.log('Checking', thumbnails.length, 'thumbnails for variant hiding:');

    thumbnails.forEach((thumb, index) => {
      const hasVariantClass = thumb.classList.contains('thumbnail-list-item--variant');
      const hasCurrentClass = thumb.classList.contains('is-current-variant-thumbnail');
      const isVisible = window.getComputedStyle(thumb).display !== 'none';
      const dataTarget = thumb.getAttribute('data-target');

      console.log(`Thumbnail ${index} (media ${dataTarget}):`, {
        hasVariantClass,
        hasCurrentClass,
        isVisible,
        cssRuleShouldHide: hasVariantClass && !hasCurrentClass,
        classes: thumb.className,
        element: thumb
      });
    });
  }

  // Also check main slides
  if (gallery.viewer) {
    const slides = gallery.viewer.querySelectorAll('[data-media-id]');
    console.log('Main slides:', slides.length);
    slides.forEach((slide, index) => {
      console.log(`Slide ${index}:`, {
        mediaId: slide.getAttribute('data-media-id'),
        classes: slide.className
      });
    });
  }
};

// Add global thumbnail click detection
document.addEventListener('DOMContentLoaded', function() {
  console.log('📄 DOM Content Loaded - Setting up thumbnail detection');

  // Add a global click listener to catch any thumbnail clicks
  document.addEventListener('click', function(event) {
    const thumbnail = event.target.closest('[data-target]');
    if (thumbnail) {
      console.log('🎯 GLOBAL THUMBNAIL CLICK DETECTED:', {
        element: thumbnail,
        dataTarget: thumbnail.getAttribute('data-target'),
        eventTarget: event.target,
        timestamp: new Date().toISOString()
      });
    }
  }, true); // Use capture phase to catch early

  console.log('✅ Global thumbnail click detection active');
});

// Add immediate click detection for thumbnails
document.addEventListener('click', function(event) {
  const thumbnail = event.target.closest('[data-target]');
  if (thumbnail) {
    console.log('🔥 IMMEDIATE THUMBNAIL CLICK:', thumbnail.getAttribute('data-target'));
  }
}, true);

if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        console.log('🚀 MediaGallery constructor called at:', new Date().toISOString());

        this.ifMediaStack = this.hasAttribute("data-media-stack");

        // Initialize with the product's featured image media ID, not variant media ID
        // This ensures we always start with the main product image
        const featuredMediaElement = this.querySelector('[id^="Slide-"]');
        this.lastVariantMediaId = featuredMediaElement ? parseInt(featuredMediaElement.dataset.mediaId) : null;

        console.log('MediaGallery initialized:', {
          ifMediaStack: this.ifMediaStack,
          lastVariantMediaId: this.lastVariantMediaId,
          hasThumbnails: !!this.thumbnails,
          hasHideVariants: this.hasAttribute("data-hide-variants")
        });

        // Debug featured image display
        console.log('=== FEATURED IMAGE DEBUG ===');
        console.log('Featured media element found:', !!this.querySelector('[id^="Slide-"]'));
        console.log('All slide elements:', this.querySelectorAll('[id^="Slide-"]').length);
        console.log('All thumbnail elements:', this.thumbnails?.querySelectorAll('[data-target]').length);

        // Debug thumbnail duplication and badges
        if (this.thumbnails) {
          const allThumbs = this.thumbnails.querySelectorAll('[data-target]');
          const thumbIds = Array.from(allThumbs).map(thumb => thumb.getAttribute('data-target'));
          console.log('Thumbnail data-target IDs:', thumbIds);
          console.log('Unique thumbnail IDs:', [...new Set(thumbIds)]);
          console.log('Duplicate thumbnails found:', thumbIds.length !== new Set(thumbIds).size);

          // Debug thumbnail badges and duplication
          console.log('=== DETAILED THUMBNAIL ANALYSIS ===');
          Array.from(allThumbs).forEach((thumb, index) => {
            const hasBadge = thumb.querySelector('.thumbnail-badge');
            const mediaId = thumb.getAttribute('data-target');
            const button = thumb.querySelector('button');
            const img = thumb.querySelector('img');
            const isVisible = window.getComputedStyle(thumb).display !== 'none';
            const isCurrent = thumb.classList.contains('is-current-variant-thumbnail');

            console.log(`Thumbnail ${index} (media ${mediaId}):`, {
              hasBadge: !!hasBadge,
              badgeType: hasBadge ? hasBadge.innerHTML.trim() : 'none',
              badgeElement: hasBadge ? hasBadge.outerHTML : 'none',
              badgeInnerHTML: hasBadge ? hasBadge.innerHTML : 'none',
              hasButton: !!button,
              hasImage: !!img,
              isVisible: isVisible,
              isCurrent: isCurrent,
              classes: thumb.className,
              buttonAriaCurrent: button ? button.getAttribute('aria-current') : 'none'
            });

            // Additional debug for empty badges
            if (hasBadge && hasBadge.innerHTML.trim() === '') {
              console.warn(`⚠️ EMPTY BADGE: Thumbnail ${index} has badge but no content!`);
              console.log('Badge element details:', hasBadge);
            }

            // Check for potential duplicates
            const duplicateThumbs = Array.from(allThumbs).filter(t => t.getAttribute('data-target') === mediaId);
            if (duplicateThumbs.length > 1) {
              console.warn(`⚠️ DUPLICATE FOUND: Media ${mediaId} appears ${duplicateThumbs.length} times in thumbnails!`);
              duplicateThumbs.forEach((dup, dupIndex) => {
                console.log(`Duplicate ${dupIndex}:`, {
                  element: dup,
                  classes: dup.className,
                  hasBadge: !!dup.querySelector('.thumbnail-badge'),
                  isVisible: window.getComputedStyle(dup).display !== 'none'
                });
              });
            }
          });
        }

        // Debug variant hiding on initialization
        if (this.hasAttribute("data-hide-variants")) {
          console.log('Variant hiding is ENABLED');

          // Check all thumbnails for variant classes
          const allThumbs = this.thumbnails?.querySelectorAll('[data-target]');
          allThumbs?.forEach((thumb, index) => {
            const hasVariantClass = thumb.classList.contains('thumbnail-list-item--variant');
            const hasCurrentClass = thumb.classList.contains('is-current-variant-thumbnail');
            const dataTarget = thumb.getAttribute('data-target');
            console.log(`Thumbnail ${index}:`, {
              dataTarget,
              hasVariantClass,
              hasCurrentClass,
              classes: thumb.className,
              shouldBeVisible: !hasVariantClass || hasCurrentClass
            });
          });

          // Check if there's a current variant thumbnail
          const currentThumb = this.thumbnails?.querySelector('.is-current-variant-thumbnail');
          if (!currentThumb) {
            console.warn('WARNING: No thumbnail has is-current-variant-thumbnail class on initialization!');
            console.log('This means ALL variant thumbnails will be hidden by CSS rule: .thumbnail-list-item--variant:not(.is-current-variant-thumbnail)');

            // Try to find the featured media thumbnail and make it current
            const featuredMediaId = this.lastVariantMediaId;
            if (featuredMediaId) {
              const featuredThumb = this.thumbnails?.querySelector(`[data-target="${featuredMediaId}"]`);
              if (featuredThumb) {
                console.log('Setting featured media thumbnail as current:', featuredMediaId);
                featuredThumb.classList.add('is-current-variant-thumbnail');
              }
            }
          }
        }

        if (!this.thumbnails) {
          console.warn('No thumbnails found, skipping event listener setup');
          return;
        }

        // Add click handlers to both li elements and button elements
        const thumbnails = this.thumbnails.querySelectorAll("[data-target]");
        console.log('Found', thumbnails.length, 'thumbnails to attach listeners to');

        thumbnails.forEach((thumbnail, index) => {
          console.log(`Attaching listener to thumbnail ${index}:`, thumbnail, 'data-target:', thumbnail.getAttribute('data-target'));

          // Store reference to bound handler
          thumbnail._mediaGalleryClickHandler = this.onThumbnailClick.bind(this);

          thumbnail.addEventListener(
            "click",
            thumbnail._mediaGalleryClickHandler,
          );

          // Also add to button elements inside thumbnails
          const button = thumbnail.querySelector("button");
          if (button) {
            console.log(`Attaching listener to button ${index}`);

            // Store reference to button handler
            thumbnail._mediaGalleryButtonHandler = (event) => {
              event.preventDefault();
              event.stopPropagation();
              console.log('Button clicked, delegating to parent');
              this.onThumbnailClick({ currentTarget: thumbnail, preventDefault: () => {}, stopPropagation: () => {} });
            };

            button.addEventListener(
              "click",
              thumbnail._mediaGalleryButtonHandler
            );
          } else {
            console.warn(`No button found in thumbnail ${index}`);
          }

          // Mark thumbnail as having listeners attached
          thumbnail.setAttribute('data-listeners-attached', 'true');
        });
        this.addEventListener("sliderChanged", this.onSlideChanged.bind(this));
      }

      get viewer() {
        return this.querySelector('[id^="Gallery-Viewer"]');
      }

      get thumbnails() {
        return this.querySelector('[id^="Gallery-Thumbnail-Slider"]');
      }

      /**
       * 媒体切换事件
       * @param event
       */
      onSlideChanged(event) {
        if (!event || !event.detail) return;

        const mediaId = event.detail.currentElement.dataset.mediaId;

        // 滚动缩略图到当前媒体
        const thumbnail = this.thumbnails.querySelector(
          `[data-target="${mediaId}"]`,
        );
        if (!thumbnail) return;

        if (!thumbnail.querySelector("button").hasAttribute("aria-current")) {
          this.setActiveThumbnail(thumbnail);
        }
        if (this.thumbnails.initSliderStatus)
          this.thumbnails.slideByElement(thumbnail); // 滚动到合适的位置
      }

      /**
       * 点击缩略图处理
       */
      onThumbnailClick(event) {
        event.preventDefault();
        event.stopPropagation();

        console.log('🖱️ THUMBNAIL CLICK: Starting click handler');
        console.log('Clicked element:', event.currentTarget);
        console.log('Data target:', event.currentTarget.getAttribute("data-target"));
        console.log('Event target:', event.target);

        const thumbnail = event.currentTarget;
        const mediaId = thumbnail.getAttribute("data-target");

        if (!mediaId) {
          console.error('❌ THUMBNAIL CLICK: No data-target found on thumbnail');
          return;
        }

        console.log('✅ THUMBNAIL CLICK: Processing click for media:', mediaId);

        // Check if this is the currently active thumbnail
        const isCurrentlyActive = thumbnail.querySelector('button')?.getAttribute('aria-current') === 'true';
        console.log('Currently active?', isCurrentlyActive);

        if (!isCurrentlyActive) {
          console.log('🔄 THUMBNAIL CLICK: Changing to new media');
        this.setActiveThumbnail(thumbnail);
          this.changeMedia(mediaId);

          // Update debug indicator
          const debugDiv = document.getElementById('media-gallery-debug');
          if (debugDiv) {
            debugDiv.textContent = `✅ Clicked: Media ${mediaId}`;
            debugDiv.style.background = 'rgba(0,150,0,0.8)';
            setTimeout(() => {
              debugDiv.style.background = 'rgba(0,0,0,0.8)';
            }, 1000);
          }
        } else {
          console.log('ℹ️ THUMBNAIL CLICK: Already active, no change needed');
        }

        console.log('🏁 THUMBNAIL CLICK: Handler completed');
      }

      // Add test function for manual thumbnail testing
      testThumbnailClicks() {
        console.log('🧪 THUMBNAIL TEST: Starting manual test');
        if (!this.thumbnails) {
          console.error('❌ THUMBNAIL TEST: No thumbnails found');
          return;
        }

        const thumbs = this.thumbnails.querySelectorAll('[data-target]');
        console.log(`🧪 THUMBNAIL TEST: Found ${thumbs.length} thumbnails to test`);

        if (thumbs.length > 1) {
          console.log('🧪 THUMBNAIL TEST: Clicking second thumbnail...');
          thumbs[1].click(); // Click the second thumbnail to test switching
        } else {
          console.log('🧪 THUMBNAIL TEST: Only one thumbnail, clicking it...');
          thumbs[0].click(); // Click the only thumbnail
        }
      }

      /**
       * 更新相册，如果需要隐藏其它变体图片，需要重新安装轮播组件
       * @param currentVariantMediaId 当前变体的 Featured Media Id
       */
      updateGallery(currentVariantMediaId) {
        console.log('updateGallery called with mediaId:', currentVariantMediaId);

        if (
          currentVariantMediaId === this.lastVariantMediaId ||
          currentVariantMediaId == null
        ) {
          console.log('updateGallery: No change needed, returning early');
          return;
        }

        this.lastVariantMediaId = currentVariantMediaId;
        console.log('updateGallery: Processing update for mediaId:', currentVariantMediaId);

        // 修改当前变体关联的媒体
        this.viewer
          .querySelectorAll(".is-current-variant-media")
          .forEach((element) =>
            element.classList.remove("is-current-variant-media"),
          );
        this.viewer
          .querySelectorAll(`[data-media-id="${currentVariantMediaId}"]`)
          .forEach((element) =>
            element.classList.add("is-current-variant-media"),
          );

        if (this.thumbnails) {
          console.log('updateGallery: Updating thumbnail classes');

          // Remove current class from all thumbnails
          const oldCurrentThumb = this.thumbnails.querySelector(".is-current-variant-thumbnail");
          if (oldCurrentThumb) {
            oldCurrentThumb.classList.remove("is-current-variant-thumbnail");
            console.log('updateGallery: Removed is-current-variant-thumbnail from:', oldCurrentThumb.getAttribute('data-target'));
          }

          // Add current class to new thumbnail
          const newCurrentThumb = this.thumbnails.querySelector(`[data-target="${currentVariantMediaId}"]`);
          if (newCurrentThumb) {
            newCurrentThumb.classList.add("is-current-variant-thumbnail");
            console.log('updateGallery: Added is-current-variant-thumbnail to:', currentVariantMediaId);
          } else {
            console.warn('updateGallery: Could not find thumbnail for mediaId:', currentVariantMediaId);
          }
        }

        // 如果开启了隐藏其它变体设置
        if (this.hasAttribute("data-hide-variants")) {
          // 切换当前变体的媒体组
          const groupName = this.viewer.querySelector(
            `[data-media-id="${currentVariantMediaId}"]`,
          )?.dataset.mediaGroup;
          this.viewer
            .querySelectorAll(".is-current-variant-media-group")
            .forEach((element) =>
              element.classList.remove("is-current-variant-media-group"),
            );
          if (groupName) {
            this.viewer
              .querySelectorAll(`[data-media-group='${groupName}']`)
              .forEach((element) => {
                element.classList.add("is-current-variant-media-group");
              });
          }

          if (this.thumbnails) {
            this.thumbnails
              .querySelectorAll(".is-current-variant-thumbnail-group")
              .forEach((element) =>
                element.classList.remove("is-current-variant-thumbnail-group"),
              );
            if (groupName) {
              this.thumbnails
                .querySelectorAll(`[data-thumbnail-group='${groupName}']`)
                .forEach((element) => {
                  element.classList.add("is-current-variant-thumbnail-group");
                });
            }
          }

          // 如果启用了隐藏其它变体媒体，需要重新初始化轮播
          if (!this.ifMediaStack) {
            this.viewer.reInstall();
            if (this.thumbnails) this.thumbnails.reInstall();
          }
        }

        this.changeMedia(currentVariantMediaId);

        // 手机端，当媒体切换的时候，返回页面顶部
        if (isMobileScreen()) {
          scrollElementToHeaderBottom(this, 16);
        }
      }

      /**
       * 设置活跃媒体
       * @param mediaId
       */
      changeMedia(mediaId) {
        const activeMedia = this.viewer.querySelector(
          `[data-media-id="${mediaId}"]`,
        );

        if (this.ifMediaStack) {
          // 如果是 Stack 布局，需要将当前变体 Featured Media 放置最前面
          activeMedia.parentElement.prepend(activeMedia);
        } else {
          // 轮播模式，切换当前轮播
          if (this.viewer.initSliderStatus)
            this.viewer.slideByElement(activeMedia);
        }
      }

      /**
       * 设置活跃缩略图
       * @param thumbnail
       */
      setActiveThumbnail(thumbnail) {
        if (!this.thumbnails || !thumbnail) return;

        this.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));

        thumbnail.querySelector("button").setAttribute("aria-current", true);
      }
    },
  );
}
